import { Injectable } from '@angular/core';
import { CanActivate } from '@angular/router';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { CancellationService } from 'src/app/cancellation/services/cancellation.service';
import { OptionType } from 'src/app/core/enums/enums';
import { LayoutService } from 'src/app/layout/services/layout.service';

import { ItineraryService } from '../../search-result/services/itinerary.service';

@Injectable()
export class Step2Guard implements CanActivate {
  constructor(
    private cancellationService: CancellationService,
    private itinerary: ItineraryService,
    private layoutService: LayoutService
  ) {}

  isThereAPaymentChannel() {
    return this.cancellationService.getPaymentChannel().pipe(
      map(paymentChannel => {
        if (!paymentChannel) {
          this.itinerary.navigateTo('/cancellation/step1');
        }
        return !!paymentChannel;
      })
    );
  }

  canActivate(): Observable<boolean> {
    this.itinerary.getPnrBaseInfo();
    this.layoutService.dispatchChangeBreadcrumb(
      this.itinerary.pnr,
      OptionType.Cancellation
    );
    return this.isThereAPaymentChannel();
  }
}
